import { SiMqtt, SiRedis, SiSupabase, SiMongodb, SiPostgresql, SiMysql } from 'react-icons/si';
import {
  LuFilter,
  LuGitBranch,
  LuTimer,
  LuCopy,
  LuMerge,
  LuCode,
  LuWebhook,
  LuBraces,
  LuArrowRightLeft,
  LuClock,
  LuSend,
  LuCalculator,
  LuChartBar,
  LuGlobe,
  LuDatabase,
  LuBinary,
  LuBrain,
  LuRadio,
  LuRouter,
  LuTable2,
} from 'react-icons/lu';

/** Carbon-aligned accent tokens (match etl-flow.css) */
export const NODE_CATEGORY_ACCENTS = {
  gateway: 'var(--accent-cyan)',
  input: 'var(--accent-green)',
  logic: 'var(--accent-purple)',
  transform: 'var(--accent-orange)',
  ble: 'var(--accent-teal)',
  output: 'var(--accent-red)',
};

export const nodeCategories = [
  {
    id: 'gateway',
    name: 'Gateway',
    color: NODE_CATEGORY_ACCENTS.gateway,
    nodes: [
      {
        type: 'turbo',
        nodeType: 'kGateway',
        label: 'KGateway',
        icon: <LuRouter />,
        subtitle: 'BLE Gateway source',
        hasInput: false,
      },
    ],
  },
  {
    id: 'input',
    name: 'Input',
    color: NODE_CATEGORY_ACCENTS.input,
    nodes: [
      {
        type: 'turbo',
        nodeType: 'mqttInput',
        label: 'MQTT In',
        icon: <SiMqtt />,
        subtitle: 'Subscribe to topic',
        hasInput: false,
      },
      {
        type: 'turbo',
        nodeType: 'httpInput',
        label: 'HTTP In',
        icon: <LuGlobe />,
        subtitle: 'Poll or receive',
        hasInput: false,
      },
    ],
  },
  {
    id: 'logic',
    name: 'Logic',
    color: NODE_CATEGORY_ACCENTS.logic,
    nodes: [
      { type: 'turbo', nodeType: 'filter', label: 'Filter', icon: <LuFilter />, subtitle: 'Condition check' },
      { type: 'turbo', nodeType: 'switch', label: 'Switch', icon: <LuGitBranch />, subtitle: 'Route by value' },
      { type: 'turbo', nodeType: 'throttle', label: 'Throttle', icon: <LuTimer />, subtitle: 'Rate limit' },
      { type: 'turbo', nodeType: 'dedupe', label: 'Dedupe', icon: <LuCopy />, subtitle: 'Remove duplicates' },
      { type: 'turbo', nodeType: 'join', label: 'Join', icon: <LuMerge />, subtitle: 'Merge streams' },
      { type: 'turbo', nodeType: 'aggregate', label: 'Aggregate', icon: <LuCalculator />, subtitle: 'Window stats' },
      { type: 'turbo', nodeType: 'window', label: 'Window', icon: <LuChartBar />, subtitle: 'Time window' },
    ],
  },
  {
    id: 'transform',
    name: 'Transform',
    color: NODE_CATEGORY_ACCENTS.transform,
    nodes: [
      { type: 'turbo', nodeType: 'jsonParser', label: 'JSON Parse', icon: <LuBraces />, subtitle: 'Parse payload' },
      { type: 'turbo', nodeType: 'bleDecoder', label: 'BLE Decoder', icon: <LuBinary />, subtitle: 'Decode bytes' },
      { type: 'turbo', nodeType: 'mapper', label: 'Mapper', icon: <LuArrowRightLeft />, subtitle: 'Map fields' },
      { type: 'turbo', nodeType: 'function', label: 'Function', icon: <LuCode />, subtitle: 'Custom JS' },
      { type: 'turbo', nodeType: 'aiTransform', label: 'AI Transform', icon: <LuBrain />, subtitle: 'AI-powered' },
    ],
  },
  {
    id: 'ble',
    name: 'BLE Devices',
    color: NODE_CATEGORY_ACCENTS.ble,
    nodes: [
      { type: 'turbo', nodeType: 'bleAutoDetect', label: 'BLE Auto-Detect', icon: <LuBrain />, subtitle: 'AI identifies & decodes' },
      { type: 'turbo', nodeType: 'bleElaPtEn', label: 'ELA P T EN', icon: <LuRadio />, subtitle: 'Temp sensor' },
      { type: 'turbo', nodeType: 'bleKbPro', label: 'KBPro', icon: <LuRadio />, subtitle: 'Temp/Humidity/Accel' },
      { type: 'turbo', nodeType: 'bleSigmaWit', label: 'SigmaWit', icon: <LuRadio />, subtitle: 'T201 sensor' },
    ],
  },
  {
    id: 'output',
    name: 'Output',
    color: NODE_CATEGORY_ACCENTS.output,
    nodes: [
      { type: 'turbo', nodeType: 'viewNode', label: 'View', icon: <LuTable2 />, subtitle: 'Display data table', hasOutput: false },
      { type: 'turbo', nodeType: 'mqttOutput', label: 'MQTT Out', icon: <SiMqtt />, subtitle: 'Publish message', hasOutput: false },
      { type: 'turbo', nodeType: 'redisSink', label: 'Redis', icon: <SiRedis />, subtitle: 'Upstash Redis', hasOutput: false },
      { type: 'turbo', nodeType: 'supabaseSink', label: 'Supabase', icon: <SiSupabase />, subtitle: 'PostgreSQL DB', hasOutput: false },
      { type: 'turbo', nodeType: 'mongoSink', label: 'MongoDB', icon: <SiMongodb />, subtitle: 'Document DB', hasOutput: false },
      { type: 'turbo', nodeType: 'postgresSink', label: 'PostgreSQL', icon: <SiPostgresql />, subtitle: 'SQL Database', hasOutput: false },
      { type: 'turbo', nodeType: 'mysqlSink', label: 'MySQL', icon: <SiMysql />, subtitle: 'SQL Database', hasOutput: false },
      { type: 'turbo', nodeType: 'natsSink', label: 'NATS', icon: <LuDatabase />, subtitle: 'Pub/Sub', hasOutput: false },
      { type: 'turbo', nodeType: 'qstashPublish', label: 'QStash', icon: <LuSend />, subtitle: 'Queue message', hasOutput: false },
      { type: 'turbo', nodeType: 'qstashSchedule', label: 'QStash Schedule', icon: <LuClock />, subtitle: 'Delayed webhook', hasOutput: false },
      { type: 'turbo', nodeType: 'webhook', label: 'Webhook', icon: <LuWebhook />, subtitle: 'HTTP request', hasOutput: false },
    ],
  },
];
